import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BellRing, ShieldAlert, ArrowRight } from "lucide-react";

const fmt = (iso) => {
  if (!iso) return null;
  try { return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" }); } catch { return null; }
};

// Small "Documents needing my action" nudge. Renders nothing when there is nothing to do.
export function DocActionNudge({ endpoint, testid = "doc-action-nudge", onOpen }) {
  const [d, setD] = useState(null);

  useEffect(() => {
    let ok = true;
    api.get(endpoint).then(({ data }) => { if (ok) setD(data); }).catch(() => { if (ok) setD(null); });
    return () => { ok = false; };
  }, [endpoint]);

  if (!d || !d.count) return null;
  const due = fmt(d.oldest_due);

  return (
    <Card data-testid={testid} className="mb-5 border-[#E9DEFB] bg-[#F7F3FF] p-4">
      <div className="flex items-start gap-3">
        <span className="h-10 w-10 rounded-xl bg-[#7C3AED]/12 text-[#7C3AED] flex items-center justify-center shrink-0">
          <BellRing size={19} />
        </span>
        <div className="min-w-0 flex-1">
          <div className="font-display font-semibold text-[15px] text-[#1C4358]" data-testid={`${testid}-message`}>{d.message}</div>
          <div className="text-[13px] text-muted-foreground mt-0.5">
            {due ? <span data-testid={`${testid}-oldest-due`}>Oldest due {due} · </span> : null}
            Let's keep things moving — take the next step when you're ready.
          </div>
          {d.disclaimer && (
            <div className="mt-2 flex items-start gap-1.5 text-[12px] text-[#92600E]" data-testid={`${testid}-disclaimer`}>
              <ShieldAlert size={13} className="shrink-0 mt-0.5" /> <span>{d.disclaimer}</span>
            </div>
          )}
        </div>
        <Button size="sm" onClick={onOpen} className="bg-[#7C3AED] hover:bg-[#6D28D9] text-white gap-1.5 h-9 rounded-full shrink-0" data-testid={`${testid}-cta`}>
          {d.cta || "Review"} <ArrowRight size={14} />
        </Button>
      </div>
    </Card>
  );
}
